<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    fullscreen
  >
    <div class="bg-white poppins position-relative min-h-100">
      <div
        class="modal-header py-3 align-center bg-white position-sticky top-0 left-0 zindex-5"
      >
        <h4 class="mb-0 font-weight-bolder poppins">
          {{ detailTitle }}
        </h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
      </div>
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <!--begin::Body-->
        <div v-for="(item, i) in other" :key="i">
          <pop-up-selector
            ref="popup"
            :item="item"
            :id="id"
            :refresher="updateData"
            :toggleDetail="toggleModal"
            :deleteDocUrl="deleteDocUrl"
          />
        </div>
        <!--end::Body-->
      </div>
    </div>
  </v-dialog>
</template>

<script>
import PopUpSelector from "@/own/components/fulfillment/asn/popup/PopUpSelector.vue";
export default {
  name: "Others",
  props: ["updateDatatable"],
  components: { PopUpSelector },
  data: () => ({
    dialog: false,
    other: null,
    id: null,
    refresherFunction: null,
    deleteDocUrl: null,
    headerData: null,
  }),
  computed: {
    detailTitle() {
      return this.headerData
        ? this.$t("asn_detail_with_reference", {
            reference: this.headerData,
          })
        : this.$t("asn_detail");
    },
  },
  methods: {
    updateData(isEditable, isToggleable) {
      this.refresherFunction(this.id, isEditable, isToggleable);
      this.$refs.popup.forEach((popup) => {
        try {
          popup.fetchData();
        } catch {
          return;
        }
      });
    },
    setData(otherData, id, refresherFunction, deleteDocUrl, headerData = null) {
      this.other = otherData;
      this.id = id;
      this.refresherFunction = refresherFunction;
      this.deleteDocUrl = deleteDocUrl;
      this.headerData = headerData;
    },
    toggleModal() {
      if (this.dialog) {
        this.other = null;
        this.id = null;
        this.refresherFunction = null;
        this.headerData = null;
        this.updateDatatable();
        this.dialog = !this.dialog;
      } else {
        this.dialog = !this.dialog;
      }
    },
  },
};
</script>
